import { get } from 'lodash';
import { isTransparent } from '@wix/shoutout-email-model-v3';
import { toRgbAsHex } from './color';
import { defaultBackgroundColor } from './defaults';
export const getBodyBackgroundColor = (composerData) => {
    const innerBackgroundColor = get(composerData, 'background.body.backgroundColor');
    const innerBackgroundColorFallback = get(composerData, 'styles.css.so-global-body.backgroundColor');
    if (isTransparent(innerBackgroundColor)) {
        return 'transparent';
    }
    if (!innerBackgroundColor && isTransparent(innerBackgroundColorFallback)) {
        return 'transparent';
    }
    return toRgbAsHex(get(composerData, 'background.body.backgroundColor') ||
        get(composerData, 'styles.css.so-global-body.backgroundColor') ||
        defaultBackgroundColor);
};
//# sourceMappingURL=get-body-background-color.js.map